import { render, staticRenderFns } from "./FindingsList.vue?vue&type=template&id=69975070&scoped=true&"
import script from "./FindingsList.vue?vue&type=script&lang=js&"
export * from "./FindingsList.vue?vue&type=script&lang=js&"
import style0 from "./FindingsList.vue?vue&type=style&index=0&id=69975070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69975070",
  null
  
)

export default component.exports